import { useMemo } from 'react';
import { useAuth } from '../context/auth';

export const useApiConfig = () => {
  const { hasToken, token, outletId, hasOverhaulEnabled } = useAuth();

  return useMemo(() => {
    const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
    const isProdEnv = process.env.NODE_ENV === "production" && 
                     !pageUrl.includes("qa") && 
                     !pageUrl.includes("pr");

    // Only use new endpoints if we have token AND hasOverhaulEnabled is true
    //TEMP: 
    // is in legacy: ACA
    const isUsingNewEndpoints = hasToken && outletId !== "0199bb54-2812-7e79-8d06-8dc5fb718434";

    if (isUsingNewEndpoints) {
      return {
        baseUrl: isProdEnv 
          ? "https://amer.collinsondesk.com/v3"
          : "https://amer-qa.collinsondesk.com/qa-v3",
        isUsingNewEndpoints: true,
        token: token,
        outletId: outletId,
        hasOverhaulEnabled: true,
      };
    }

    return {
      baseUrl: "",
      isUsingNewEndpoints: false,
      token: null,
      outletId: null,
      hasOverhaulEnabled: false,
    };
  }, [hasToken, token, outletId, hasOverhaulEnabled]);
};
